import { brand } from '@/config/brands'
import { useUserStore } from '@/stores'

declare function fbq(command: string, event: string, params?: object, options?: object): void

function isFbqAvailable() {
  return typeof fbq !== 'undefined'
}

/**
 * 不会重复触发 PageView。memberId 就绪后调用一次，后续所有 fbq track 请求自动带 ud[external_id]。
 */
export function setFbqUserData(memberId: string | number) {
  if (!isFbqAvailable() || !memberId)
    return
  // pixelId 与 HTML 入口解析保持一致（HTML 会把解析后的 id 持久化进 localStorage）
  const pixelId = localStorage.getItem('fb_pixel_code') || '803439134848114'
  fbq('init', pixelId, { external_id: String(memberId) })
}

/**
 * 生成 fbq eventId
 * 格式：{env}_{brand}_h5_{eventName}_{timestamp}_{memberId|guest}_{random8}
 */
export function createFbEventId(eventName: string) {
  const env = import.meta.env.MODE.includes('production') ? 'p' : 't'
  const memberId = useUserStore().memberId || 'guest'
  const random = Math.random().toString(36).slice(2, 10).padEnd(8, '0')
  return `${env}_${brand}_h5_${eventName}_${Date.now()}_${memberId}_${random}`
}

/**
 * 仅客户端 fbq 上报（InitiateCheckout：eventId 随下单接口透传后端，不走 newTrack）
 */
export function fbqTrack(event: string, params: object, eventId: string) {
  if (!isFbqAvailable())
    return
  fbq('track', event, params, { eventID: eventId })
}
